// Homepage: config-driven split numbers and payout timing, the Shilled coin CA pill, and the payouts strip
// (GET /api/paid + /api/stats). The bubbles and the 3D hero stay inline in index.html.
import { api } from "../lib/api.js";
import { epochName, isAddress, pumpUrl } from "../lib/config.js";
import { esc, formatSol, handle, pct, shortAddr, timeAgo, toBig } from "../lib/format.js";
import { boot } from "../lib/page.js";
import { toast } from "../lib/toast.js";
import { $, copyText } from "../lib/ui.js";

/**
 * The approved copy says 70% / 30%. If the server's split is different, rewrite those numbers in the split
 * section and the fee-split FAQ answer (text nodes only, so the markup and styling stay exactly as designed)
 * and the bar.
 */
function applySplit(cfg) {
  const creator = Number(cfg.split.creatorBps), shill = Number(cfg.split.shillBps);
  if (!(creator >= 0 && shill >= 0) || (creator === 7000 && shill === 3000)) return;
  for (const el of [document.getElementById("split"), document.getElementById("faq-a3")]) {
    if (!el) continue;
    const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    for (let n = walker.nextNode(); n; n = walker.nextNode()) {
      if (/(70|30)%/.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace(/(70|30)%/g, (m, v) => (v === "70" ? pct(creator) : pct(shill)));
    }
  }
  const section = document.getElementById("split");
  const a = section && section.querySelector(".sc-bar .seg.a"), b = section && section.querySelector(".sc-bar .seg.b");
  if (a && b) { a.style.flex = String(creator / 100); b.style.flex = String(shill / 100); }
}

/** Payout timing ("half hour") and the AI-check sentence, from /api/config. */
function applyRules(cfg) {
  document.querySelectorAll("[data-epoch-name]").forEach((el) => { el.textContent = epochName(cfg); });
  document.querySelectorAll("[data-ai]").forEach((el) => { el.hidden = !cfg.aiCheck; });
}

function coinFromConfig(cfg) {
  const c = cfg.coin;
  if (!c) return null;
  if (typeof c === "string") return isAddress(c) ? { token: c, symbol: "SHILLED" } : null;
  const token = c.token || c.address || c.mint;
  if (!token || !isAddress(token)) return null;
  return { token, symbol: String(c.symbol || "SHILLED").replace(/^\$/, ""), tradeUrl: c.tradeUrl };
}

function renderCa(cfg) {
  const coin = coinFromConfig(cfg);
  const caText = $("#caText"), copyBtn = $("#copyCa"), trade = $("#tradeLink");
  if (!coin) return; // keeps "Drops at launch"
  $("#caTicker").textContent = `$${coin.symbol}`;
  caText.classList.remove("pending");
  caText.title = coin.token;
  caText.innerHTML = `<span class="full">${esc(coin.token)}</span><span class="short">${esc(shortAddr(coin.token))}</span>`;
  copyBtn.hidden = false;
  trade.href = coin.tradeUrl || pumpUrl(coin.token);
  trade.textContent = "Trade on pump.fun";
  trade.hidden = false;
  copyBtn.addEventListener("click", async () => {
    if (await copyText(coin.token)) {
      copyBtn.textContent = "Copied";
      setTimeout(() => { copyBtn.textContent = "Copy"; }, 1400);
    } else {
      const r = document.createRange();
      r.selectNodeContents(caText.querySelector(".full") || caText);
      const sel = getSelection();
      sel.removeAllRanges();
      sel.addRange(r);
      toast("Address selected. Press Ctrl+C or ⌘C to copy it.");
    }
  });
}

function payoutItem(p, dupe) {
  const who = p.xHandle ? handle(p.xHandle) : shortAddr(p.account);
  const coins = (Array.isArray(p.coins) ? p.coins : []).map((c) => `$${String(c.symbol || "").replace(/^\$/, "")}`).filter((s) => s.length > 1).join(" ");
  const ago = typeof p.ago === "string" && p.ago ? p.ago : timeAgo(p.ts);
  return `<a class="paid-item" href="/paid/${esc(p.tx)}" data-testid="paid-item"${dupe ? ' aria-hidden="true" tabindex="-1"' : ""}><span class="paid-dot"></span><span class="paid-who">${esc(who)}</span><span>got paid</span><strong>${esc(formatSol(p.amountLamports))} SOL</strong>${coins ? `<span class="paid-coin">${esc(coins)}</span>` : ""}<span class="paid-ago">${esc(ago)}</span></a>`;
}

async function renderPayouts() {
  const [paid, stats] = await Promise.allSettled([api.paid(20), api.stats()]);
  if (stats.status === "fulfilled" && stats.value && toBig(stats.value.totalPaidLamports) > 0n) {
    const tp = $("#totalPaid");
    tp.textContent = `${formatSol(stats.value.totalPaidLamports)} SOL`;
    tp.hidden = false;
  }
  const list = paid.status === "fulfilled" && Array.isArray(paid.value) ? paid.value.filter((p) => p && p.tx) : [];
  if (list.length) {
    $("#paidTrack").innerHTML = `<div class="paid-run">${list.map((p) => payoutItem(p, false)).join("")}${list.map((p) => payoutItem(p, true)).join("")}</div>`;
  }
}

async function main() {
  const cfg = await boot();
  applySplit(cfg);
  applyRules(cfg);
  renderCa(cfg);
  await renderPayouts();
}

main().catch((e) => console.error(e));
